import React from 'react';

interface FormSelectProps<T extends string> {
  label: string;
  value: T;
  onChange: (value: T) => void;
  options: { value: T; label: string }[];
  placeholder?: string;
  hideLabel?: boolean;
}

export const FormSelect = <T extends string>({
  label,
  value,
  onChange,
  options,
  placeholder,
  hideLabel = false,
}: FormSelectProps<T>) => {
  return (
    <div>
      <label
        className={
          hideLabel ? 'sr-only' : 'block text-sm font-medium text-gray-700 dark:text-gray-200'
        }
      >
        {label}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as T)}
        className="mt-1 block w-full rounded-md border border-gray-200 bg-white px-3 py-2 shadow-sm transition duration-150 ease-in-out hover:border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:hover:border-gray-500 sm:text-sm"
        aria-label={hideLabel ? label : undefined}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
